import { css, jsx } from '@emotion/react';
import { AlertBanner } from '../AlertBanner';
import { UNIVERSAL_SIDEBAR_WIDTH, UNIVERSAL_NAV_ZINDEX, UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH, BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_COLLAPSED, BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_OPEN, } from '../../../universal-nav/constants';
import { UniversalFooter } from '../../../universal-footer/components/UniversalFooter';
import { UniversalLayoutQueryContainer } from './UniversalLayoutQueryContainer';
import { UniversalNav } from '../../../universal-nav/components/UniversalNav';
import { UniversalNavProvider } from '../../../universal-nav/hooks';
import { useUniversalNavContext } from '../../../universal-nav/hooks/useUniversalNavContext';
import InAppSidebar from '../../../universal-nav/components/UniversalSidebar/InAppSidebar/InAppSidebar';
import { useRef } from 'react';
import { boxSizing } from '../../../utils/style-mixins/reset';
const Styles = {
    root: css `
    ${boxSizing};
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
    alertBanner: css `
    ${boxSizing};
    &:empty {
      display: none;
    }
  `,
    grid: css `
    ${boxSizing};
    flex: 1;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'head'
      'main'
      'foot';
    gap: 0;
  `,
    gridWithSidebar: (isSidebarForcedOpen) => css `
    ${boxSizing};
    grid-template-columns: 0px 1fr;
    grid-template-areas:
      'head head'
      'sidebar main'
      'sidebar foot';

    @media (min-width: ${BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_COLLAPSED}px) {
      grid-template-columns: ${UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH}px 1fr;
    }

    @media (min-width: ${BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_OPEN}px) {
      grid-template-columns: ${isSidebarForcedOpen
        ? UNIVERSAL_SIDEBAR_WIDTH
        : UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH}px 1fr;
    }
  `,
    head: css `
    ${boxSizing};
    grid-area: head;
    z-index: ${UNIVERSAL_NAV_ZINDEX};
  `,
    main: css `
    ${boxSizing};
    grid-area: main;
    position: relative;
  `,
    foot: css `
    ${boxSizing};
    grid-area: foot;
  `,
};
const UniversalLayoutInner = (props) => {
    const { currentUrl, currentAccountId, isSidebarForcedOpen, shouldRenderSidebar, } = useUniversalNavContext();
    const ref = useRef(null);
    return (jsx("div", { ref: ref, css: Styles.root, "data-zds": true },
        props.renderAlertBanner && (jsx("div", { css: Styles.alertBanner, "data-testid": "UniversalLayoutAlertBanner", "data-zds": true }, props.renderAlertBanner(props))),
        jsx("div", { css: [
                Styles.grid,
                shouldRenderSidebar && Styles.gridWithSidebar(isSidebarForcedOpen),
            ], "data-zds": true },
            props.renderHeader && (jsx("div", { css: Styles.head, "data-zds": true }, props.renderHeader(props))),
            shouldRenderSidebar && (jsx(InAppSidebar, { rootRef: ref, currentAccountId: currentAccountId, selectedHref: currentUrl })),
            jsx("main", { css: Styles.main, id: props.mainContentId, "data-zds": true }, props.children),
            props.renderFooter && (jsx("div", { css: Styles.foot, "data-zds": true }, props.renderFooter(props))))));
};
export const UniversalLayout = ({ children, currentUrl, shouldSidebarBeInitiallyCollapsed = false, trackEvent, accountData = undefined, accountsListData = undefined, apiHostname = '', bffHostname = '', mainContentId = 'mainContent', mode = undefined, sessionData = undefined, shouldRenderAlphabetNav = undefined, shouldRenderSeoLinks = undefined, shouldRenderTOS = undefined, showSimplifiedFooter = undefined, urlPathPrefix = undefined, renderAlertBanner = (props) => (jsx(AlertBanner, { trackEvent: props.trackEvent })), renderNotifications = () => null, renderHeader = (props) => {
    return (jsx(UniversalNav, { renderNotifications: props.renderNotifications, skipLinkHref: `#${props.mainContentId}` }));
}, renderFooter = (props) => {
    return (jsx(UniversalFooter, { shouldRenderAlphabetNav: props.shouldRenderAlphabetNav, shouldRenderSeoLinks: props.shouldRenderSeoLinks, showSimplifiedFooter: props.showSimplifiedFooter }));
}, }) => {
    const props = {
        children,
        currentUrl,
        trackEvent,
        accountData,
        accountsListData,
        apiHostname,
        bffHostname,
        mainContentId,
        mode,
        sessionData,
        shouldRenderAlphabetNav,
        shouldRenderSeoLinks,
        shouldRenderTOS,
        showSimplifiedFooter,
        urlPathPrefix,
        renderAlertBanner,
        renderNotifications,
        renderHeader,
        renderFooter,
    };
    return (jsx(UniversalLayoutQueryContainer, null,
        jsx(UniversalNavProvider, { accountData: accountData, accountsListData: accountsListData, shouldSidebarBeInitiallyCollapsed: shouldSidebarBeInitiallyCollapsed, currentUrl: currentUrl, urlPathPrefix: urlPathPrefix, sessionData: sessionData, mode: mode, shouldRenderTOS: shouldRenderTOS, apiHostname: apiHostname, bffHostname: bffHostname },
            jsx(UniversalLayoutInner, Object.assign({}, props)))));
};
//# sourceMappingURL=UniversalLayout.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
